import { render, staticRenderFns } from "./CadastroServicosPacs.vue?vue&type=template&id=d36a512a&"
import script from "./CadastroServicosPacs.vue?vue&type=script&lang=js&"
export * from "./CadastroServicosPacs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports